import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class BendedAddPrice extends Component{
	constructor(){
        super();

        this.createDimension = this.createDimension.bind(this);
        this.state = {
          userId : "",
          user :{}          
        };
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
              var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/");
            }
        }); 

    } 

    componentWillUnmount(){
    	this.listener()  
    }

    addDimensionPrice(product){
    	ref.child("BendedPrice").push(product).then(alert("New Dimension and price  has been added"))
    }

    createDimension(event){
    	event.preventDefault();
        if (!isNaN(this.price_4MM.value) && !isNaN(this.price_5MM.value) && !isNaN(this.price_6MM.value) && !isNaN(this.price_8MM.value) && this.dimension.value !==""){
        	const product={
        		dimension: this.dimension.value,
        		price_4MM: this.price_4MM.value,
                price_5MM: this.price_5MM.value,
                price_6MM: this.price_6MM.value,
                price_6MM: this.price_8MM.value,
                status : "Active"
            }

        	this.addDimensionPrice(product);
        	this.productForm.reset();
        }else{
            alert("Error")
        }
    }

   

	render(){
                   
	    return (
	    	<div id="page-wrapper">
	            <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
	                <Sidebar  role={this.state.user.role} />
	                <div id="main-container">
	                    <Header />
	                    <div id="page-content">
	                        <Title title="Add Bended Price" />
	                        <div className="block">
                                <div className="block-title">
                                    <h2><i className="fa fa-pencil"></i> <strong>Product</strong> Information</h2>
                                </div>
						    	<form className="form-horizontal form-bordered" ref={(input) => {this.productForm=input}}  onSubmit={(e)=>this.createDimension(e)}>

						    		<div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Dimension</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.dimension=input}} type="text" required/>
                                        </div>
                                    </div>                                    

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.4MM)</label>
                                        <div className="col-md-2">
                                        	<div className="input-group">
	                                            <div className="input-group-addon"><i className="fa fa-rub"></i></div>
	                                            <input className="form-control" ref={(input) => {this.price_4MM=input}} type="text" required />
	                                        </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.5MM)</label>
                                        <div className="col-md-2">
                                            <div className="input-group">
                                                <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                <input className="form-control" ref={(input) => {this.price_5MM=input}} type="text" required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.6MM)</label>
                                        <div className="col-md-2">
                                            <div className="input-group">
                                                <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                <input className="form-control" ref={(input) => {this.price_6MM=input}} type="text" required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.8MM)</label>
                                        <div className="col-md-2">
                                            <div className="input-group">
                                                <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                <input className="form-control" ref={(input) => {this.price_8MM=input}} type="text" required />
                                            </div>
                                        </div>
                                    </div>

							    	<div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Add Dimension</button>
                                        </div>
                                    </div>
						    	</form>
	                        </div>
	                    </div>
	                    <Footer />
	                </div>
	            </div>
	        </div>
		)
	}
}

export default  BendedAddPrice;



// WEBPACK FOOTER //
// ./src/components/BendedAddPrice.js